module.exports = __webpack_public_path__ + "img/dfrancisco.891dcc30.png";